import clsx from "clsx";

// MUI
import Button from "@mui/material/Button";
import { ReactNode } from "react";

type FilterButtonProps = Readonly<{
	label: ReactNode;
	isDisabled: boolean;
	selected?: boolean;
	onToggleSelected: () => void;
}>;

export default function FilterButton(props: FilterButtonProps) {
	const { label, isDisabled, selected, onToggleSelected } = props;

	return (
		<Button
			variant="outlined"
			disabled={isDisabled}
			onClick={onToggleSelected} // Let the parent handle toggling & filtering
			classes={{
				root: clsx({
					"h-[30px] !rounded-md !normal-case": true,
					"!border-disabled": !selected,
					"!border-primary !shadow-[0px_2px_8px_0px_rgba(0,0,0,0.25)]": selected,
				}),
				outlined: clsx({
					"!font-montserrat !text-xs !text-default !font-medium": true,
					"!text-[#808080]": !selected && !isDisabled,
				}),
				disabled: clsx({
					"!bg-disabled !text-white !outline-white": true,
					"!border-none": isDisabled,
				}),
			}}
		>
			{label}
		</Button>
	);
}
